<script>
    import Modal from '../shared/Modal.svelte';
    import ModalContent from '../shared/ModalContent.svelte';

    export let title = 'Title here';
    export let titleToolTip = null;
</script>

<style>
    @media (min-width: 1024px) {
        header {
            background: linear-gradient(177.21deg, #005397 0.77%, #00467f 76.64%);
        }
    }

    .title {
        font-family: Camphor W01 Bold;
    }

</style>

<header class="flex-shrink rounded-t">
    <div class="flex items-center justify-center flex-no-wrap">
        <h2 class="title p-8 pb-0 pr-2 lg:pb-8 text-center lg:text-white text-3xl">{title}</h2>
        {#if titleToolTip}
            <Modal>
                <ModalContent content="{titleToolTip}" />
            </Modal>
        {/if}
    </div>
</header>